module.exports = __webpack_public_path__ + "img/NMP-Logo.1420c85b.webp";